import { render, staticRenderFns } from "./LegalShell.vue?vue&type=template&id=1c29efd4"
import script from "./LegalShell.vue?vue&type=script&lang=js"
export * from "./LegalShell.vue?vue&type=script&lang=js"
import style0 from "./LegalShell.vue?vue&type=style&index=0&id=1c29efd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports